export default "__VITE_ASSET__B4p$5kCp__"